/* ORVE Discover: animated discovery-set builder */
(() => {
  if (window.__orveDiscover) return;
  window.__orveDiscover = true;

  const RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const T = {
    choose: 'Choose [n] scents',
    chooseOne: 'Choose your scent',
    more: '[n] more to pick',
    moreOne: '1 more to pick',
    ready: 'Your set is ready',
    readyOne: 'Your card is ready',
    full: 'Your set is full. Tap a picked vial to swap it out.',
    trimmed: 'Set changed to [n]. We kept your first picks.',
    adding: 'Adding',
    added: 'Added',
    addedMsg: 'Added to your bag',
    error: 'Could not add to bag. Please try again.',
    addOne: 'Add to my set',
    remove: 'Remove from set',
    swap: 'Choose this one',
    prop: 'Scents'
  };

  const init = (root) => {
    if (!root || root.dataset.odReady === '1') return;
    root.dataset.odReady = '1';
    root.classList.add('od--js');

    const q = (s) => root.querySelector(s);
    const qa = (s) => Array.from(root.querySelectorAll(s));

    const tiers = qa('[data-od-tier]');
    const scents = qa('[data-od-scent]');
    const slotsEl = q('[data-od-slots]');
    const countEl = q('[data-od-count]');
    const maxEl = q('[data-od-max]');
    const statusEl = q('[data-od-status]');
    const priceEl = q('[data-od-price]');
    const addBtn = q('[data-od-add]');
    const addLabel = q('[data-od-add-label]');
    const addSub = q('[data-od-add-sub]');
    const bar = q('[data-od-bar]');
    const dock = q('[data-od-dock]');
    const toast = q('[data-od-toast]');
    const pv = {
      wrap: q('[data-od-preview]'),
      media: q('[data-od-pv-media]'),
      img: q('[data-od-pv-img]'),
      name: q('[data-od-pv-name]'),
      tag: q('[data-od-pv-tag]'),
      fam: q('[data-od-pv-fam]'),
      top: q('[data-od-pv-top]'),
      heart: q('[data-od-pv-heart]'),
      base: q('[data-od-pv-base]'),
      toggle: q('[data-od-pv-toggle]'),
      link: q('[data-od-pv-link]')
    };
    const addText = (addLabel && addLabel.textContent.trim()) || 'Add to bag';

    if (!tiers.length || !scents.length || !addBtn) return;

    // takeover: hide the standard product layout on the discovery product page
    if (root.dataset.takeover === '1') {
      document.querySelectorAll('.product-information').forEach((el) => {
        const sec = el.closest('.shopify-section');
        if (sec && !sec.contains(root)) sec.style.display = 'none';
      });
    }

    let tier = tiers.find((t) => t.classList.contains('is-on') && !t.disabled) || tiers.find((t) => !t.disabled) || tiers[0];
    let picks = [];
    let busy = false;
    let pvCurrent = scents[0];

    const max = () => Math.max(1, Number(tier && tier.dataset.count) || 1);
    const visible = (el) => {
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
    };

    const status = () => {
      const n = max();
      const left = n - picks.length;
      if (left <= 0) return n === 1 ? T.readyOne : T.ready;
      if (!picks.length) return n === 1 ? T.chooseOne : T.choose.replace('[n]', n);
      return left === 1 ? T.moreOne : T.more.replace('[n]', left);
    };

    let toastTimer;
    const say = (msg) => {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('is-on'), 2800);
    };

    const shake = () => {
      if (!dock || RM) return;
      dock.classList.remove('is-shake');
      void dock.offsetWidth;
      dock.classList.add('is-shake');
    };

    const bump = () => {
      if (!countEl || RM) return;
      countEl.classList.remove('is-bump');
      void countEl.offsetWidth;
      countEl.classList.add('is-bump');
    };

    const renderSlots = () => {
      const n = max();
      while (slotsEl.children.length < n) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'od__slot';
        const img = document.createElement('img');
        img.alt = '';
        img.decoding = 'async';
        const num = document.createElement('span');
        num.className = 'od__slot-n';
        b.appendChild(img);
        b.appendChild(num);
        slotsEl.appendChild(b);
      }
      while (slotsEl.children.length > n) slotsEl.lastElementChild.remove();
      Array.from(slotsEl.children).forEach((slot, i) => {
        const s = picks[i];
        const img = slot.querySelector('img');
        slot.querySelector('.od__slot-n').textContent = String(i + 1).padStart(2, '0');
        if (s) {
          slot.classList.add('is-filled');
          slot.style.setProperty('--glow', s.dataset.glow);
          if (img.getAttribute('src') !== s.dataset.vial) img.src = s.dataset.vial;
          img.alt = s.dataset.name;
          slot.dataset.handle = s.dataset.handle;
          slot.setAttribute('aria-label', 'Remove ' + s.dataset.name);
        } else {
          slot.classList.remove('is-filled', 'is-landing');
          slot.style.removeProperty('--glow');
          img.removeAttribute('src');
          img.alt = '';
          delete slot.dataset.handle;
          slot.setAttribute('aria-label', 'Empty slot ' + (i + 1));
        }
      });
    };

    const syncToggle = () => {
      if (!pv.toggle || !pvCurrent) return;
      const on = picks.includes(pvCurrent);
      const n = max();
      pv.toggle.classList.toggle('is-on', on);
      pv.toggle.textContent = on ? T.remove : (n === 1 && picks.length ? T.swap : T.addOne);
    };

    const render = () => {
      const n = max();
      const c = picks.length;
      const left = n - c;
      if (countEl) countEl.textContent = c;
      if (maxEl) maxEl.textContent = n;
      if (bar) bar.style.width = Math.min(100, (c / n) * 100) + '%';
      root.classList.toggle('is-full', left <= 0);
      root.classList.toggle('is-card', n === 1);
      scents.forEach((s) => {
        const i = picks.indexOf(s);
        const li = s.closest('.od__vial');
        if (li) li.classList.toggle('is-picked', i > -1);
        s.setAttribute('aria-pressed', i > -1 ? 'true' : 'false');
        const badge = s.querySelector('[data-od-order]');
        if (badge) badge.textContent = i > -1 ? (n === 1 ? String.fromCharCode(10003) : String(i + 1)) : '';
      });
      renderSlots();
      addBtn.disabled = left > 0 || busy;
      if (statusEl) statusEl.textContent = status();
      if (priceEl) priceEl.textContent = tier.dataset.price;
      if (addSub) addSub.textContent = left > 0 ? status() : tier.dataset.price;
      syncToggle();
      if (typeof syncDock === 'function') syncDock();
    };

    const burst = (s) => {
      if (RM) return;
      const host = s.querySelector('.od__vial-stage');
      if (!host) return;
      const b = document.createElement('span');
      b.className = 'od__burst';
      b.appendChild(document.createElement('b'));
      for (let k = 0; k < 12; k++) {
        const i = document.createElement('i');
        i.style.setProperty('--r', (k * 30 + Math.random() * 16) + 'deg');
        i.style.setProperty('--d', (38 + Math.random() * 34) + 'px');
        b.appendChild(i);
      }
      host.appendChild(b);
      setTimeout(() => b.remove(), 950);
    };

    const fly = (s, index) => {
      const slot = slotsEl.children[index];
      const src = s.querySelector('.od__vial-bob img');
      if (!slot || !src) return;
      if (RM || !visible(src) || !visible(slot)) {
        slot.classList.add('is-pop');
        setTimeout(() => slot.classList.remove('is-pop'), 500);
        return;
      }
      const a = src.getBoundingClientRect();
      const b = slot.getBoundingClientRect();
      slot.classList.add('is-landing');
      const ghost = new Image();
      ghost.src = src.currentSrc || src.src;
      ghost.alt = '';
      ghost.className = 'od-ghost';
      ghost.style.left = a.left + 'px';
      ghost.style.top = a.top + 'px';
      ghost.style.width = a.width + 'px';
      ghost.style.height = a.height + 'px';
      ghost.style.filter = 'drop-shadow(0 0 16px rgb(' + s.dataset.glow + ' / .95))';
      document.body.appendChild(ghost);
      const targetH = b.height * 0.84;
      const scale = targetH / a.height;
      const dx = b.left + (b.width - a.width * scale) / 2 - a.left;
      const dy = b.top + (b.height - targetH) / 2 - a.top;
      const lift = Math.min(140, Math.abs(dy) * 0.35 + 40);
      const anim = ghost.animate([
        { transform: 'translate(0px, 0px) scale(1) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - lift) + 'px) scale(' + (1 + scale) / 2 + ') rotate(-10deg)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + scale + ') rotate(0deg)', opacity: 0.85 }
      ], { duration: 780, easing: 'cubic-bezier(.5,0,.25,1)' });
      let finished = false;
      const done = () => {
        if (finished) return;
        finished = true;
        ghost.remove();
        slot.classList.remove('is-landing');
        slot.classList.add('is-pop');
        setTimeout(() => slot.classList.remove('is-pop'), 500);
      };
      anim.onfinish = done;
      anim.oncancel = done;
      setTimeout(done, 1200);
    };

    const showPreview = (s, force) => {
      if (!pv.wrap || !s || (s === pvCurrent && !force)) return;
      pvCurrent = s;
      const d = s.dataset;
      pv.wrap.style.setProperty('--pv-glow', d.glow);
      if (pv.name) pv.name.textContent = d.name;
      if (pv.tag) pv.tag.textContent = d.tagline || '';
      if (pv.fam) pv.fam.textContent = d.family || '';
      if (pv.top) pv.top.textContent = d.top || '';
      if (pv.heart) pv.heart.textContent = d.heart || '';
      if (pv.base) pv.base.textContent = d.base || '';
      if (pv.link && d.url) pv.link.href = d.url;
      if (pv.img && d.card && pv.img.getAttribute('src') !== d.card) {
        pv.media.classList.add('is-swapping');
        const next = new Image();
        const swap = () => {
          if (pvCurrent !== s) return;
          pv.img.src = d.card;
          pv.img.alt = d.name + ' discovery card';
          requestAnimationFrame(() => {
            pv.media.classList.remove('is-swapping');
            if (!RM) {
              pv.media.classList.remove('is-scan');
              void pv.media.offsetWidth;
              pv.media.classList.add('is-scan');
            }
          });
        };
        next.onload = swap;
        next.onerror = swap;
        next.src = d.card;
      }
      if (!RM) {
        pv.wrap.classList.remove('is-text-in');
        void pv.wrap.offsetWidth;
        pv.wrap.classList.add('is-text-in');
      }
      syncToggle();
    };

    const pick = (s) => {
      if (busy) return;
      const n = max();
      const i = picks.indexOf(s);
      if (i > -1) {
        picks.splice(i, 1);
        render();
        bump();
        return;
      }
      if (picks.length >= n) {
        if (n === 1) {
          picks = [s];
          render();
          fly(s, 0);
          burst(s);
          return;
        }
        say(T.full);
        shake();
        return;
      }
      picks.push(s);
      render();
      fly(s, picks.length - 1);
      burst(s);
      bump();
      if (picks.length === n) setTimeout(() => say(n === 1 ? T.readyOne : T.ready), 650);
    };

    // set (tier) selection
    const chooseTier = (t) => {
      if (!t || t.disabled || t === tier) return;
      tier = t;
      tiers.forEach((x) => {
        const on = x === t;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const n = max();
      const trimmed = picks.length > n;
      if (trimmed) picks = picks.slice(0, n);
      render();
      if (trimmed) say(T.trimmed.replace('[n]', n));
    };
    tiers.forEach((t, idx) => {
      t.addEventListener('click', () => chooseTier(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        const dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
        for (let k = 1; k <= tiers.length; k++) {
          const next = tiers[(idx + dir * k + tiers.length * 2) % tiers.length];
          if (!next.disabled) { next.focus(); chooseTier(next); break; }
        }
      });
    });

    // scent selection
    scents.forEach((s) => {
      s.addEventListener('click', () => {
        showPreview(s);
        pick(s);
      });
      s.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') showPreview(s);
      });
      s.addEventListener('focus', () => showPreview(s));
    });

    if (pv.toggle) {
      pv.toggle.addEventListener('click', () => {
        if (pvCurrent) pick(pvCurrent);
      });
    }

    slotsEl.addEventListener('click', (e) => {
      const slot = e.target.closest('.od__slot.is-filled');
      if (!slot || busy) return;
      const s = scents.find((x) => x.dataset.handle === slot.dataset.handle);
      if (!s) return;
      picks.splice(picks.indexOf(s), 1);
      render();
      bump();
    });

    // add to bag
    addBtn.addEventListener('click', async () => {
      const n = max();
      if (addBtn.disabled || busy || picks.length !== n) return;
      busy = true;
      root.classList.add('is-busy');
      render();
      if (addLabel) addLabel.textContent = T.adding + String.fromCharCode(8230);
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map((c) => c.dataset.sectionId);
      const props = {};
      props[T.prop] = picks.map((s) => s.dataset.name).join(', ');
      const body = { items: [{ id: Number(tier.dataset.variant), quantity: 1, properties: props }] };
      if (sectionIds.length) body.sections = sectionIds.join(',');
      try {
        const r = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const res = await r.json();
        if (!r.ok) throw res;
        const cart = await fetch(rootUrl + 'cart.js').then((x) => x.json());
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: cart,
          sourceId: 'orve-discover',
          data: { source: 'orve-discover', itemCount: cart.item_count, productId: root.dataset.productId, variantId: tier.dataset.variant, sections: res.sections }
        };
        document.dispatchEvent(ev);
        root.classList.add('is-added');
        if (addLabel) addLabel.textContent = T.added + ' ' + String.fromCharCode(10003);
        say(T.addedMsg);
        setTimeout(() => {
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            try { drawer.open(); } catch (err) { /* ignore */ }
          } else {
            window.location.href = rootUrl + 'cart';
          }
          picks = [];
          busy = false;
          root.classList.remove('is-busy', 'is-added');
          if (addLabel) addLabel.textContent = addText;
          render();
        }, 700);
      } catch (err) {
        busy = false;
        root.classList.remove('is-busy');
        if (addLabel) addLabel.textContent = addText;
        say((err && (err.description || err.message)) || T.error);
        render();
      }
    });

    // heading decode effect
    const decode = () => {
      if (RM) return;
      qa('.od__t1 .od__ch').forEach((c, i) => {
        const final = c.dataset.ch || c.textContent;
        const w = c.getBoundingClientRect().width;
        if (w) c.style.width = w + 'px';
        let k = 0;
        const total = 7 + i;
        const tick = () => {
          k += 1;
          if (k >= total) {
            c.textContent = final;
            c.style.width = '';
            return;
          }
          c.textContent = GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
          setTimeout(tick, 48);
        };
        setTimeout(tick, 180 + i * 65);
      });
    };

    const preload = () => {
      const run = () => scents.forEach((s) => {
        if (s.dataset.card) { const im = new Image(); im.decoding = 'async'; im.src = s.dataset.card; }
      });
      if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 3000 });
      else setTimeout(run, 1500);
    };

    // reveal + pause when off screen
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          root.classList.toggle('is-visible', en.isIntersecting);
          if (en.isIntersecting && !root.classList.contains('is-in')) {
            root.classList.add('is-in');
            decode();
            preload();
          }
        });
      }, { threshold: 0.08 });
      io.observe(root);
    } else {
      root.classList.add('is-in', 'is-visible');
    }

    // show the dock once the scents step is on screen (or something is picked)
    const scentStep = q('.od__step--scents');
    let stepSeen = false;
    const syncDock = () => root.classList.toggle('dock-on', stepSeen || picks.length > 0);
    if (scentStep && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((en) => { stepSeen = en.isIntersecting; syncDock(); });
      }, { threshold: 0, rootMargin: '0px 0px -35% 0px' }).observe(scentStep);
    } else {
      stepSeen = true;
    }

    // subtle pointer parallax
    if (!RM) {
      let raf = 0;
      root.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse' || raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          const r = root.getBoundingClientRect();
          root.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
          root.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
        });
      });
    }

    render();
  };

  const boot = (scope) => {
    const s = scope || document;
    if (s.matches && s.matches('[data-od]')) init(s);
    s.querySelectorAll('[data-od]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
